import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { useTrades } from "../../hooks";

export const useInspectionTemplateSelectionViewModel = () => {
  const [inspectionTemplates, setInspectionTemplates] = useState([]);

  const stateManager = useComponentState();
  const { trades, getTrades } = useTrades();

  const loadAllInspectionTemplates = () => {
    stateManager.run(async () => {
      const { status, data } = await taskService.inspectionTemplates.getAll({
        sort: "name",
      });
      if (status === HTTP_STATUSES.OK) {
        setInspectionTemplates(data);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    trades,
    inspectionTemplates,
    loadAllInspectionTemplates,
    getTrades,
  };
};
